import { v4 as uuidv4 } from 'uuid';

const generateUuid = () => {
  if (self?.crypto?.randomUUID) {
    return self.crypto.randomUUID();
  }
  return uuidv4();
}

export default generateUuid;
